var dispatchEvent = function (view, event) { return view.dispatchEvent(event); };
var pasteContent = function (view, content, option) {
    if (!DataTransfer || !ClipboardEvent)
        return false;
    var plainText = option.plainText === true;
    var dataTransfer = new DataTransfer();
    if (plainText) {
        dataTransfer.setData('text/plain', content);
    }
    else {
        dataTransfer.setData('text/plain', content.replace(/<br.*?>/g, '\n').replace(/<.*?>/g, ''));
        dataTransfer.setData('text/html', content);
    }
    var fakeEvent = new ClipboardEvent('paste', { clipboardData: dataTransfer });
    dispatchEvent(view, fakeEvent);
    return true;
};
export { dispatchEvent, pasteContent };
//# sourceMappingURL=action.js.map